/**
 * sg-cart-kaartje.js
 *
 * Globale handler voor de YourSurprise kaartje-toggle in de winkelwagen.
 *
 * Waarom hier (asset) i.p.v. inline in de snippet?
 *   Bij quantity-changes re-renderd Dawn de cart-section via innerHTML.
 *   innerHTML executeert GEEN <script>-tags. Dus inline-JS draait alleen
 *   bij initial page-load, niet bij re-render — listeners zouden weg zijn.
 *   Dit script draait 1x, en bind via MutationObserver elke nieuwe
 *   .cart-kaartje die door re-render in de DOM komt.
 */
(function () {
  'use strict';

  if (window.__sgCartKaartjeLoaded) return;
  window.__sgCartKaartjeLoaded = true;

  var CHECK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

  function generateBundleKey() {
    return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  /* ──────────────────────────────────────────────────────────────
     Section-render helpers — laten cart-pagina + drawer + bubble
     opnieuw rendereren via Shopify's Section Rendering API zodat
     de getoonde parent-prijs meteen klopt na een kaartje-toggle.
     ────────────────────────────────────────────────────────────── */
  function sectionsToRefresh() {
    var sections = [];
    var mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems && mainCartItems.dataset.id) {
      sections.push({ id: 'main-cart-items', section: mainCartItems.dataset.id, selector: '.js-contents' });
    }
    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter && mainCartFooter.dataset.id) {
      sections.push({ id: 'main-cart-footer', section: mainCartFooter.dataset.id, selector: '.js-contents' });
    }
    if (document.querySelector('cart-drawer')) {
      sections.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    }
    sections.push({ id: 'shopify-section-cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return sections;
  }

  function pickInnerHTML(html, selector) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = selector ? doc.querySelector(selector) : null;
    if (el) return el.innerHTML;
    var fallback = doc.querySelector('.shopify-section');
    return fallback ? fallback.innerHTML : doc.body.innerHTML;
  }

  function applySections(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    /* Bewaar de tekst die op dit moment in de zichtbare textareas staat,
       zodat user-typing tijdens een refresh niet verloren gaat. We keyen
       per line-key (parent) en field-name. */
    var textBuffer = {};
    document.querySelectorAll('.cart-kaartje').forEach(function (s) {
      var key = s.dataset.lineKey;
      if (!key) return;
      var fields = {};
      s.querySelectorAll('textarea[data-field-name]').forEach(function (ta) {
        var name = ta.dataset.fieldName;
        if (name && ta.value) fields[name] = ta.value;
      });
      if (Object.keys(fields).length) textBuffer[key] = fields;
    });

    sectionsToRefresh().forEach(function (section) {
      var html = parsedState.sections[section.section];
      if (!html) return;
      var container = document.getElementById(section.id);
      if (!container) return;
      var target = section.selector ? container.querySelector(section.selector) : container;
      if (!target) target = container;
      var newHTML = pickInnerHTML(html, section.selector);
      if (newHTML != null) target.innerHTML = newHTML;
    });

    /* Zet de bewaarde tekst terug in de nieuwe DOM (per line-key & field-name).
       Zo verlies je geen typewerk als de section-refresh midden in typen valt. */
    Object.keys(textBuffer).forEach(function (key) {
      document.querySelectorAll('.cart-kaartje[data-line-key="' + key + '"]').forEach(function (s) {
        var fields = textBuffer[key];
        Object.keys(fields).forEach(function (name) {
          var ta = s.querySelector('textarea[data-field-name="' + name + '"]');
          if (ta && !ta.value && fields[name]) {
            ta.value = fields[name];
            var counter = ta.parentElement && ta.parentElement.querySelector('.cart-kaartje__counter');
            if (counter) counter.textContent = ta.value.length + ' / 150';
          }
        });
      });
    });
  }

  /* Toon een spinner gecentreerd in de quantity-cel (op gelijke hoogte
     met de min/plus/qty/verwijder-knoppen) terwijl de toggle-actie loopt.
     Bij applySections wordt de DOM vervangen en is de class vanzelf weg. */
  function setParentLoading(sec, isLoading) {
    var row = sec.closest('.cart-item');
    if (!row) return;
    var qtyCell = row.querySelector('.cart-item__quantity');
    if (!qtyCell) return;
    if (isLoading) qtyCell.classList.add('cart-item__quantity--kaartje-loading');
    else qtyCell.classList.remove('cart-item__quantity--kaartje-loading');
  }

  function bindOne(sec) {
    if (!sec || sec.dataset.bound === 'true') return;
    sec.dataset.bound = 'true';

    var sw       = sec.querySelector('.cart-kaartje__switch');
    var content  = sec.querySelector('.cart-kaartje__content');
    var inner    = sec.querySelector('.cart-kaartje__inner');
    var statusEl = sec.querySelector('.cart-kaartje__status');
    if (!sw || !content || !inner) return;

    var lineKey = sec.dataset.lineKey;
    var lineQty = parseInt(sec.dataset.lineQuantity, 10) || 1;
    var mode    = sec.dataset.mode || 'property';
    var cardVariantId   = sec.dataset.cardVariantId || '';
    var cardLineKey     = sec.dataset.cardLineKey || '';
    var parentBundleKey = sec.dataset.parentBundleKey || '';
    var saveTimer = null;

    function setStatus(text, kind) {
      if (!statusEl) return;
      if (kind === 'saved') {
        statusEl.innerHTML = CHECK_SVG + ' <span>' + text + '</span>';
      } else {
        statusEl.textContent = text;
      }
      statusEl.dataset.kind = kind || 'idle';
    }

    function hasContent() {
      var any = false;
      inner.querySelectorAll('textarea').forEach(function (ta) {
        if ((ta.value || '').trim()) any = true;
      });
      return any;
    }

    function showSavedIfHasContent() {
      if (hasContent() && sec.dataset.state === 'on') {
        setStatus('Opgeslagen', 'saved');
      } else {
        setStatus('', 'idle');
      }
    }

    function updateCounter(ta) {
      var wrap = ta.parentElement;
      var counter = wrap && wrap.querySelector('.cart-kaartje__counter');
      if (counter) counter.textContent = (ta.value || '').length + ' / 150';
    }

    function collectAllProperties() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = (cart.items || []).find(function (l) { return l.key === lineKey; });
          if (!line) return null;
          var base = {};
          Object.keys(line.properties || {}).forEach(function (k) {
            if (k === 'Kaartje' || /^Kaartje \d+$/.test(k)) return;
            if (line.properties[k] != null) base[k] = line.properties[k];
          });
          lineQty = line.quantity || 1;
          sec.dataset.lineQuantity = String(lineQty);
          /* Voor lineitem-mode: verifieer/refresh ook de bundle-key en kaartje-line-key uit de cart. */
          if (mode === 'lineitem') {
            if (line.properties && line.properties._bundle) {
              parentBundleKey = line.properties._bundle;
              sec.dataset.parentBundleKey = parentBundleKey;
            }
            if (parentBundleKey) {
              var kaartjeLine = (cart.items || []).find(function (l) {
                return l.properties && l.properties._kaartje_voor === parentBundleKey;
              });
              if (kaartjeLine) {
                cardLineKey = kaartjeLine.key;
                sec.dataset.cardLineKey = cardLineKey;
              } else {
                cardLineKey = '';
                sec.dataset.cardLineKey = '';
              }
            }
          }
          return base;
        });
    }

    function buildKaartjeProps(includeMessages) {
      var out = {};
      if (!includeMessages) return out;
      var textareas = inner.querySelectorAll('textarea');
      var values = [];
      textareas.forEach(function (ta) { values.push((ta.value || '').trim()); });

      if (values.length === 0) return out;
      if (values.length === 1) {
        if (values[0]) out['Kaartje'] = values[0];
      } else {
        values.forEach(function (v, i) {
          if (v) out['Kaartje ' + (i + 1)] = v;
        });
      }
      return out;
    }

    function saveToCart(opts) {
      opts = opts || {};
      var refreshSections = opts.refreshSections === true;
      var isOn = sec.dataset.state === 'on';
      setStatus('Bezig met opslaan…', 'pending');

      return collectAllProperties().then(function (base) {
        if (!base) {
          setStatus('Regel niet gevonden — ververs het winkelmandje', 'error');
          return;
        }
        var kaartjeProps = buildKaartjeProps(isOn);
        var fullProps = Object.assign({}, base, kaartjeProps);

        var body = {
          id: lineKey,
          quantity: lineQty,
          properties: fullProps
        };
        if (refreshSections) {
          body.sections = sectionsToRefresh().map(function (s) { return s.section; });
          body.sections_url = window.location.pathname;
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) throw new Error('cart/change gaf HTTP ' + r.status);
          return r.json();
        }).then(function (newCart) {
          /* Line-key kan veranderen na property-update — pak nieuwe.
             Voor YS-items matchen we op _yoursurprise_uniqueid (uniek per
             gepersonaliseerd ontwerp). Voor andere items op _bundle (uniek
             per parent product). Zonder een unieke match-key zou find()
             "undefined === undefined" als true zien en op de verkeerde
             line landen — dat veroorzaakte de "Opslaan mislukt" foutjes. */
          var matchKey = null;
          var matchValue = null;
          if (base._yoursurprise_uniqueid) {
            matchKey = '_yoursurprise_uniqueid';
            matchValue = base._yoursurprise_uniqueid;
          } else if (base._bundle) {
            matchKey = '_bundle';
            matchValue = base._bundle;
          }
          if (matchKey) {
            var newLine = (newCart.items || []).find(function (l) {
              var p = l.properties || {};
              return p[matchKey] === matchValue;
            });
            if (newLine && newLine.key !== lineKey) {
              lineKey = newLine.key;
              sec.dataset.lineKey = lineKey;
            }
          }
          showSavedIfHasContent();

          /* Ververs DOM met de nieuwe section-HTML zodat de parent-prijs
             meteen de kaartje-prijs meeneemt (of weer afhaalt). */
          if (refreshSections) {
            applySections(newCart);
            /* Bind de nieuwe .cart-kaartje elementen direct — anders moet
               MutationObserver eerst draaien en kunnen de eerste keystrokes
               van de gebruiker in de nieuwe textarea verloren gaan. */
            bindAll();
            /* Safety net: als applySections de oude DOM NIET heeft vervangen
               (bv. sections ontbreken in response), zit sec nog in de DOM en
               blijft de spinner staan. Dan handmatig uitzetten. */
            if (sec.isConnected) setParentLoading(sec, false);
          }

          /* Trigger Dawn's cart-sync zodat totalen / drawer refresh. */
          if (window.PUB_SUB_EVENTS && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-kaartje' });
          }
        });
      }).catch(function (err) {
        console.error('[YS cart-kaartje] save fout:', err);
        /* Alleen 'Opslaan mislukt' tonen als er échte tekst was om op te
           slaan. Bij een leeg kaartje is een falende save geen verlies voor
           de gebruiker — de volgende save (met tekst) kan het opnieuw
           proberen, en een rode foutmelding bij een leeg kaartje is alleen
           maar verwarrend. */
        if (hasContent()) {
          setStatus('Opslaan mislukt — probeer opnieuw', 'error');
        } else {
          setStatus('', 'idle');
        }
        if (sec.isConnected) setParentLoading(sec, false);
      });
    }

    function scheduleSave() {
      if (saveTimer) clearTimeout(saveTimer);
      saveTimer = setTimeout(saveToCart, 600);
    }

    /* Voor lineitem-mode: kaartje als apart cart-line beheren */
    function ensureKaartjeLineExists() {
      if (mode !== 'lineitem') return Promise.resolve();
      if (cardLineKey) return Promise.resolve(); /* al aanwezig */

      /* 1) Zorg dat parent een _bundle property heeft */
      return collectAllProperties().then(function (base) {
        if (!base) throw new Error('parent line niet gevonden');
        var bundleKey = base._bundle || generateBundleKey();
        var needsParentUpdate = !base._bundle;

        var p = Promise.resolve();
        if (needsParentUpdate) {
          var fullProps = Object.assign({}, base, { _bundle: bundleKey });
          p = fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: lineQty, properties: fullProps })
          }).then(function (r) {
            if (!r.ok) throw new Error('parent-update mislukte');
            return r.json();
          }).then(function (newCart) {
            /* Line-key kan veranderen door property-update. */
            var newLine = (newCart.items || []).find(function (l) {
              var pr = l.properties || {};
              return pr._bundle === bundleKey;
            });
            if (newLine && newLine.key !== lineKey) {
              lineKey = newLine.key;
              sec.dataset.lineKey = lineKey;
            }
          });
        }

        return p.then(function () {
          parentBundleKey = bundleKey;
          sec.dataset.parentBundleKey = bundleKey;

          /* 2) Voeg kaartje line-item toe */
          if (!cardVariantId) throw new Error('Geen kaartje-variant ingesteld voor deze leverancier');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: parseInt(cardVariantId, 10),
                quantity: lineQty,
                properties: { '_kaartje_voor': bundleKey }
              }]
            })
          }).then(function (r) {
            if (!r.ok) throw new Error('kaartje add mislukte');
            return r.json();
          });
        }).then(function () {
          /* Pak de nieuwe line-key van het kaartje */
          return fetch('/cart.js').then(function (r) { return r.json(); });
        }).then(function (cart) {
          var kaartjeLine = (cart.items || []).find(function (l) {
            return l.properties && l.properties._kaartje_voor === parentBundleKey;
          });
          if (kaartjeLine) {
            cardLineKey = kaartjeLine.key;
            sec.dataset.cardLineKey = cardLineKey;
          }
        });
      });
    }

    function removeKaartjeLine() {
      if (mode !== 'lineitem') return Promise.resolve();
      if (!cardLineKey) return Promise.resolve();
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: cardLineKey, quantity: 0 })
      }).then(function (r) {
        if (!r.ok) throw new Error('kaartje verwijderen mislukt');
        return r.json();
      }).then(function () {
        cardLineKey = '';
        sec.dataset.cardLineKey = '';
      });
    }

    /* Toggle aan/uit */
    sw.addEventListener('click', function () {
      var nowOn = sec.dataset.state === 'off';
      sec.dataset.state = nowOn ? 'on' : 'off';
      sw.setAttribute('aria-pressed', nowOn ? 'true' : 'false');
      content.classList.toggle('cart-kaartje__content--open', nowOn);

      if (nowOn) {
        setTimeout(function () {
          var first = inner.querySelector('textarea');
          if (first) first.focus();
        }, 150);
      }

      if (saveTimer) clearTimeout(saveTimer);

      setStatus('Bezig met opslaan…', 'pending');

      /* Alleen bij lineitem-mode (betaalde kaartjes) verandert de prijs in de
         winkelwagen — daar ververst de DOM om die prijs te tonen. Bij YS
         (property-mode, gratis kaartje) is een refresh niet nodig en zou hij
         de content alleen maar dichtflappen midden in het typen. */
      var willRefresh = (mode === 'lineitem');
      if (willRefresh) setParentLoading(sec, true);

      var prep = nowOn ? ensureKaartjeLineExists() : removeKaartjeLine();

      prep.then(function () {
        return saveToCart({ refreshSections: willRefresh });
      }).catch(function (err) {
        console.error('[YS cart-kaartje] toggle fout:', err);
        /* Idem als saveToCart: bij leeg kaartje geen rode melding tonen. */
        if (hasContent()) {
          setStatus('Opslaan mislukt — probeer opnieuw', 'error');
        } else {
          setStatus('', 'idle');
        }
        if (willRefresh) setParentLoading(sec, false);
      });
    });

    /* Tekst aanpassen → karakterteller + debounced opslaan */
    inner.querySelectorAll('textarea').forEach(function (ta) {
      ta.addEventListener('input', function () {
        updateCounter(ta);
        scheduleSave();
      });
      ta.addEventListener('blur', function () {
        if (saveTimer) { clearTimeout(saveTimer); saveTimer = null; saveToCart(); }
      });
    });

    /* Init status */
    showSavedIfHasContent();
  }

  function bindAll() {
    document.querySelectorAll('.cart-kaartje').forEach(bindOne);
  }

  /* Initial */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  /* Re-bind na DOM-rerender (quantity-change, drawer-update, etc.) */
  var observer = new MutationObserver(function () { bindAll(); });
  function attachObserver() {
    var roots = document.querySelectorAll('cart-items, cart-drawer, #main-cart-items');
    roots.forEach(function (r) {
      observer.observe(r, { childList: true, subtree: true });
    });
    if (roots.length === 0) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }

  /* Ook luisteren op Dawn's PubSub (snellere binding bij API-cart-updates). */
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(bindAll, 50);
    });
  }
})();
